import { render, staticRenderFns } from "./style_message.vue?vue&type=template&id=40e0e1be"
import script from "./style_message.vue?vue&type=script&lang=js"
export * from "./style_message.vue?vue&type=script&lang=js"
import style0 from "./style_message.vue?vue&type=style&index=0&id=40e0e1be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports